import { Injectable } from '@angular/core';

import { AutoTodoRule } from '../../models/auto-todo-rule';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class AutoTodoRuleService extends BackendBaseService {
  url: string = 'auto_todo_rules';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  save(autoTodoRule: AutoTodoRule): Promise<any> {
    return super.save({
      id: autoTodoRule.id,
      auto_todo_rule: autoTodoRule
    });
  }
}
